<template>
  <nav class="sidebar-main" id="sidebar-main">
    <li
      class="left-arrow"
      :class="{
        'd-none':
          layout.settings.layout_type == 'rtl'
            ? hideLeftArrowRTL
            : hideLeftArrow,
      }"
      @click="
        layoutobject.split(' ').includes('horizontal-wrapper') &&
        layout.settings.layout_type === 'rtl'
          ? scrollToLeftRTL()
          : scrollToLeft()
      "
    ></li>
    <Navmenu />
    <li
      class="right-arrow"
      :class="{
        'd-none':
          layout.settings.layout_type == 'rtl'
            ? hideRightArrowRTL
            : hideRightArrow,
      }"
      @click="
        layoutobject == 'horizontal_sidebar' &&
        layout.settings.layout_type == 'rtl'
          ? scrollToRightRTL()
          : scrollToRight()
      "
    ></li>
  </nav>
</template>
<script>
import { mapState } from "vuex";
import { layoutClasses } from "../../constants/layout";
import Navmenu from "./navmenu.vue";
export default {
  name: "Nav",
  components: {
    Navmenu,
  },
  data() {
    return {
      layoutobj: {},
    };
  },
  computed: {
    ...mapState({
      layout: (state) => state.layout.layout,
      hideRightArrowRTL: (state) => state.menu.hideRightArrowRTL,
      hideLeftArrowRTL: (state) => state.menu.hideLeftArrowRTL,
      hideRightArrow: (state) => state.menu.hideRightArrow,
      hideLeftArrow: (state) => state.menu.hideLeftArrow,
      width: (state) => state.menu.width,
      height: (state) => state.menu.height,
      margin: (state) => state.menu.margin,
      menuWidth: (state) => state.menu.menuWidth,
    }),
    layoutobject: {
      get: function () {
        return JSON.parse(
          JSON.stringify(
            layoutClasses.find(
              (item) => Object.keys(item).pop() === this.layout.settings.layout
            )
          )
        )[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find(
          (item) => Object.keys(item).pop() === this.layout.settings.layout
        );
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
          this.layout.settings.layout
        ];
        return this.layoutobj;
      },
    },
  },
  methods: {
    scrollToRightRTL() {
      this.temp = this.width + this.margin;
      if (this.temp === 0) {
        this.$store.commit('menu/setMargin', this.temp);
        this.$store.commit('menu/setHideRightArrowRTL', false);
      } else {
        this.$store.commit('menu/setMargin', this.margin + this.width);
        this.$store.commit('menu/setHideRightArrowRTL', false);
        this.$store.commit('menu/setHideLeftArrowRTL', false);
      }
    },
    scrollToLeftRTL() {
      if (this.margin <= -this.width) {
        this.$store.commit('menu/setMargin', this.margin + (-this.width));
        this.$store.commit('menu/setHideLeftArrowRTL', true);
      } else {
        this.$store.commit('menu/setMargin', this.margin + (-this.width));
        this.$store.commit('menu/setHideRightArrowRTL', false);
        this.$store.commit('menu/setActiveOverlay', false);
      }
    },
    scrollToLeft() {
      if (this.margin >= -this.width) {
        this.$store.commit('menu/setMargin', 0);
        this.$store.commit('menu/setHideLeftArrow', true);
      } else {
        this.$store.commit('menu/setMargin', this.margin + this.width);
        this.$store.commit('menu/setHideRightArrow', false);
      }
    },
    scrollToRight() {
      this.temp = this.width - this.margin;
      if (
        this.temp + this.width >
        this.menuWidth
      ) {
        this.$store.commit('menu/setMargin', -this.temp);
        this.$store.commit('menu/setHideLeftArrow', false);
        if (this.temp == 4410) {
          this.$store.commit('menu/setHideRightArrow', true);
        }
      } else {
        this.$store.commit('menu/setMargin', this.margin + (-this.width));
        this.$store.commit('menu/setHideLeftArrow', false);
      }
    },
  },
};
</script>
